export const queryKeys = {
  apps: {
    all: ['apps'],
    detail: (id) => ['apps', id],
    queue: ['apps', 'queue'],
    summary: ['apps', 'summary'],
  },
  user: {
    spending: ['user', 'spending'],
    settings: ['user', 'settings'],
  },
  charges: {
    byApp: (appId) => ['charges', appId],
  },
  admin: {
    app: (id) => ['admin', 'app', id],
    queue: ['admin', 'queue'],
    quotesNeeded: ['admin', 'quotesNeeded'],
    readyToLive: ['admin', 'readyToLive'],
    paymentIssues: ['admin', 'paymentIssues'],
    appsNoPayment: ['admin', 'appsNoPayment'],
    apps: ['admin', 'apps'],
    errors: ['admin', 'errors'],
    error: (id) => ['admin', 'errors', id],
    emailTemplates: ['admin', 'emailTemplates'],
    emailTemplatePreview: (id) => ['admin', 'emailTemplatePreview', id],
    stats: ['admin', 'stats'],
  },
  crm: {
    contacts: ['crm', 'contacts'],
    contact: (id) => ['crm', 'contacts', id],
    opportunities: ['crm', 'opportunities'],
    opportunity: (id) => ['crm', 'opportunities', id],
    sourceOptions: ['crm', 'sourceOptions'],
    stats: ['crm', 'stats'],
    myAccess: ['crm', 'myAccess'],
    salespersonAccess: ['crm', 'salespersonAccess'],
  },
};
